import { ListHeader } from 'components/molecules/ListHeader';

export const ApiKeyTemplateListHeader = () => (
  <ListHeader columns={['テンプレート名']} templateColumns="1fr" />
);
